import Req from '../../$axios';

const serviceModule = {
  // 角色列表
  getRoleList(params) {
    return Req({
      url: 'roles/index',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 权限列表
  permissionsIndex(params) {
    return Req({
      url: 'permissions/permissionsIndex',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  //新增角色
  addRole(params) {
    return Req({
      url: 'roles/store',
      method: 'post',
      isJSON: true,
      tip: true,
      isAlertErr: true,
    }, params);
  },
  //角色详情
  roleDetail(params) {
    return Req({
      url: 'roles/read',
      method: 'get',
      isJSON: true,
      tip: true,
      isAlertErr: true,
    }, params);
  },
  // 编辑角色
  updateRole(params) {
    return Req({
      url: 'roles/update',
      method: 'post',
      isJSON: true,
      tip: true,
      isAlertErr: true,
    }, params);
  },
  // 删除角色
  deleteRole(params) {
    return Req({
      url: 'roles/delete',
      method: 'delete',
      isJSON: true,
      tip: true,
      isAlertErr: true,
    }, params);
  },
  removeUsersForRole(params) {
    return Req({
      url: 'roles/removeUsersForRole',
      method: 'post',
      isJSON: true,
      tip: true,
      isAlertErr: true,
    }, params);
  },
};

export default {
  ...serviceModule
};
